/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CreateUserFromWebLaboratoryAliases {
  BUTTON_CONFIRM_ACTION = 'button-confirm-action',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FORM_CREATE_NEW_USER = 'form-create-new-user',
  GLOBAL_ACTIONS_1 = 'global-actions-1',
  INPUT_LOGIN = 'input-login',
  LAYOUT_2 = 'layout-2',
  LOADER = 'loader',
  LOGIN_FIELD = 'login-field',
  MODAL_CREATE_USER_FROM_WEB_LABORATORY = 'modal-create-user-from-web-laboratory',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_BTNS_ACTIONS = 'panel-btns-actions',
  PANEL_LOADER = 'panel-loader',
  PASSWORD_CONFIRM_FIELD = 'password-confirm-field',
  PASSWORD_CONFIRM_INPUT = 'password-confirm-input',
  PASSWORD_FIELD = 'password-field',
  PASSWORD_INPUT = 'password-input',
}
export { CreateUserFromWebLaboratoryAliases };
